import { Ref } from 'vue';
import { FieldHtmlNameUtil, HekateDisplayForm } from 'www-shared';
import DriftBotUtil from '../../../../../util/DriftBotUtil';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import AbstractSignupScreenWithNewsletterForm from './AbstractSignupScreenWithNewsletterForm';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import UnifiedSignupEmailType from '../session-info/UnifiedSignupEmailType';
import UnifiedSignupPersona from '../session-info/UnifiedSignupPersona';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';

export default class SignupSuccessSignupScreen extends AbstractSignupScreenWithNewsletterForm {
  public readonly screenName: UnifiedSignupScreenName = 'uss-signup-success';

  constructor({
    sessionInfo,
    formDefinition,
    isBackButtonHidden,
    signupSurveyDiv,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>,
    formDefinition: Ref<HekateDisplayForm>,
    isBackButtonHidden: Ref<boolean>,
    signupSurveyDiv: HTMLDivElement | null,
  }) {
    super({
      formDefinition, isBackButtonHidden, sessionInfo, signupSurveyDiv,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const {
      emailStatus,
    } = this.sessionInfo.value;
    if (emailStatus !== 'DELIVERED' && emailStatus !== 'VERIFIED') {
      return false;
    }

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.completedDetailsScreens.push(this.screenName);
    return true;
  }

  public async initWatchers(): Promise<void> {
    super.initWatchers();

    document.querySelectorAll('[hekate-data="email"]').forEach((elm) => {
      const firstName = this.getField(FieldHtmlNameUtil.email).val;
      elm.textContent = `${firstName}`;
    });

    const isGeneric = this.sessionInfo.value.emailType
      && this.sessionInfo.value.emailType.compareTo(UnifiedSignupEmailType.fromString('generic'));

    const showDiscoDriftBot = !isGeneric
      && this.sessionInfo.value.isDiscoEligible
      && this.sessionInfo.value.chosenPlan?.compareTo(UnifiedSignupPlan.pro);

    if (showDiscoDriftBot) {
      DriftBotUtil.showDriftBotOrThrow({ playbook: 'DiscoFastlane', formDefinition: this.formDefinition });
    }

    const wasShownPro = this.sessionInfo.value.intent?.compareTo(UnifiedSignupIntent.bizIntent) && this.sessionInfo.value.persona?.compareTo(UnifiedSignupPersona.proPerson);
    const showFreePlanProDriftBot = this.sessionInfo.value.chosenPlan?.compareTo(UnifiedSignupPlan.free) && wasShownPro;
    if (showFreePlanProDriftBot) {
      DriftBotUtil.showDriftBotOrThrow({ playbook: 'FreePlanPro', formDefinition: this.formDefinition });
    }

    this.isBackButtonHidden.value = true;
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 100;
  }

  public async initListeners({ partialDiv }: { partialDiv: HTMLDivElement; }): Promise<void> {
    await super.initListeners({ partialDiv });
  }
}
